"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boroughsDto = void 0;
exports.boroughsDto = [
    "manhattan",
    "brooklyn",
    "queens",
    "bronx",
    "staten-island",
];
